import React from 'react';
import PropTypes from 'prop-types';

import PaymentMethod, { BUSINESS_PROFILE_TYPE, BUSINESS_ACCOUNT_TYPE } from 'models/payment-method';

const propTypes = {
  paymentMethod: PropTypes.instanceOf(PaymentMethod).isRequired,
  selected: PropTypes.bool,
};

const defaultProps = {
  selected: false,
};

const SavedPaymentPaymentMethodExpenseMemo = ({ selected, paymentMethod }) => {
  if (!selected || !(paymentMethod.type === BUSINESS_ACCOUNT_TYPE || paymentMethod.type === BUSINESS_PROFILE_TYPE)) {
    return null;
  }

  return (
    <div className="row expense-memo">
      <div className="col-md-offset-1 col-md-7 padding-left-0-gte-md padding-right-2x-gte-md">
        <input
          type="text"
          id="expenseMemo"
          name="expenseMemo"
          className="form-control"
          placeholder="Expense Memo"
          required
        />
      </div>
    </div>
  );
};

SavedPaymentPaymentMethodExpenseMemo.propTypes = propTypes;
SavedPaymentPaymentMethodExpenseMemo.defaultProps = defaultProps;
export default SavedPaymentPaymentMethodExpenseMemo;
